<template>
  <div class="rootContainer" ref="ccc" :style="{height:screenHeight }">

    <!--导航条-->
    <van-icon @click="$router.go(-1)" class="go-back" name="arrow-left" />
    <!-- <navigation title="用户注册"></navigation> -->
    <div class="login-top">
      <div class="login-text">
        <span>注册新用户
        </span>
        <div class="line"></div>
      </div>
      <div class="login-icon"></div>
    </div>
    <!--注册信息-->
    <div class="filedContainer">
      <van-row>
        <van-col class="colLeft" span="2">
          <van-icon class="iconfont" class-prefix='icon' name='shouji1' style="font-size: 20px" />
        </van-col>
        <van-col class="colRight" span="22">
          <van-field v-model="data.mobile" type="number" placeholder="输入手机号码" />
        </van-col>
      </van-row>

      <van-row>
        <van-col class="colLeft" span="2">
          <van-icon class="iconfont" class-prefix='icon' name='yanzhengma2' style="font-size: 20px" />
        </van-col>
        <van-col class="colRight" span="22">
          <van-field v-model="data.code" center clearable placeholder="请输入短信验证码">
            <template #button>
              <van-button size="small" color="#D6BE93" @click="getCodeEv" v-if="getCode" type="primary">获取验证码</van-button>
              <div class="has-get-code" v-else>{{count}}秒后重发</div>
            </template>
          </van-field>
        </van-col>
      </van-row>

      <van-row>
        <van-col class="colLeft" span="2">
          <van-icon class="iconfont" class-prefix='icon' name='mima' style="font-size: 20px" />
        </van-col>
        <van-col class="colRight" span="18">
          <van-field v-model="data.password" :type="isPwd" placeholder="请输入登录密码" />
        </van-col>
        <van-col class="colBottom" span="4">
          <van-icon class="iconfont" class-prefix='icon' @click="isPwd == 'password' ? isPwd = 'text':isPwd = 'password'" name='yanjing' style="font-size: 20px;" />
        </van-col>
      </van-row>

      <van-row>
        <van-col class="colLeft" span="2">
          <van-icon class="iconfont" class-prefix='icon' name='mima' style="font-size: 20px" />
        </van-col>
        <van-col class="colRight" span="18">
          <van-field v-model="data.rePassword" :type="isRepwd" placeholder="请再次输入登录密码" />
        </van-col>
        <van-col class="colBottom" span="4">
          <van-icon class="iconfont" class-prefix='icon' @click="isRepwd == 'password' ? isRepwd = 'text':isRepwd = 'password'" name='yanjing' style="font-size: 20px;" />
        </van-col>
      </van-row>

      <van-button color="#D6BE93" class="btSubmitStyle" @click="registerUser" type="primary">注册</van-button>

    </div>

    <div class="checkboxStyle" v-show="isShow">
      <van-checkbox checked-color="#D6BE93" icon-size="17px" @change="checkedChangedEv" v-model="checked">注册即代表同意 </van-checkbox> &nbsp;&nbsp;
      <span @click="userTreaty">软件许可及服务协议 </span>
    </div>

  </div>
</template>

<script>
import navigation from "../../components/navigation";
import "../../assets/appicons/font_1719792_w8dw4niwvmq/iconfont.css";
import { register, authRegCaptcha } from "@/api/index";
import { Dialog } from "vant";

export default {
  name: "register",
  components: {
    navigation,
  },
  data() {
    return {
      screenHOld: "",
      screenHNew: "",
      screenHeight: "",
      isShow: true,
      checked: this.$store.state.base.agreement,
      getCode: true,
      timer: null,
      isPwd: "password",
      isRepwd: "password",
      count: "",
      data: {
        mobile: "", //手机号
        password: "", //密码
        rePassword: "", //确认密码
        uuid: "",
        code: "", //验证码(因短信验证码暂未续费,code随意填写)
      },
    };
  },
  activated() {
    this.checked = this.$store.state.base.agreement;
  },
  mounted() {
    this.screenHNew = document.body.clientHeight;
    this.screenHOld = document.body.clientHeight;
    this.screenHeight = document.body.clientHeight + "px";
    window.onresize = () => {
      return (() => {
        this.screenHNew = document.body.clientHeight;
        if (this.screenHOld > this.screenHNew) {
          this.isShow = false;
        } else {
          this.isShow = true;
        }
      })();
    };
  },

  methods: {
    checkedChangedEv(e) {
      console.log(e);
      this.$store.commit("SET_AGREEMENT", e);
    },
    getCodeEv() {
      if (/^1[3456789]\d{9}$/.test(this.data.mobile)) {
        let mobile = {
          mobile: this.data.mobile,
        };
        authRegCaptcha(mobile).then((res) => {
          console.log(res);
          if (res.data.return_code == 0) {
            this.getCode = false;
            const TIME_COUNT = 60;
            this.data.uuid = res.data.data.uuid;
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.show = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.getCode = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
          } else {
            Dialog.alert({
              message: res.data.return_message,
            }).then(() => {
              // on close
            });
          }
        });
      } else {
        Dialog.alert({
          title: "提示",
          message: "手机号格式错误",
        }).then(() => {
          // on close
        });
      }
    },

    userTreaty() {
      this.$router.push("/agreement");
    },
    registerUser() {
      if (!this.checked) {
        Dialog.alert({
          title: "提示",
          message: "请先勾选用户协议",
        });
        return;
      }
      if (
        this.data.mobile == "" ||
        this.data.password == "" ||
        this.data.rePassword == "" ||
        this.data.code == ""
      ) {
        Dialog.alert({
          title: "提示",
          message: "请填写正确填写数据",
        });
        return;
      }
      if (this.data.password != this.data.rePassword) {
        Dialog.alert({
          title: "提示",
          message: "密码不一致",
        });
        return;
      }
      console.log(this.data);
      register(this.data).then((res) => {
        console.log(res);
        if (res.data.errno == 0) {
          this.$router.go(-1);
        } else {
          Dialog.alert({
            title: "提示",
            message: res.data.errmsg,
          });
        }
      });
    },
  },
};
</script>



<style  lang="scss" scoped>
.colLeft {
  background-color: white;
  height: 40px;
  /*flex 布局*/
  display: flex;
  /*实现垂直居中*/
  align-items: center;
  /*实现水平居中*/
  justify-content: center;
  text-align: justify;
}
.colRight {
  // background-color: transparent;
  height: 40px;
  /*flex 布局*/
  display: flex;
  /*实现垂直居中*/
  align-items: center;
  /*实现水平居中*/
  justify-content: center;
  text-align: justify;
}
.colBottom {
  // background-color: transparent;
  height: 40px;
  /*flex 布局*/
  display: flex;
  /*实现垂直居中*/
  align-items: center;
  /*实现水平居中*/
  justify-content: center;
  text-align: justify;
}

.rootContainer {
  background-color: white;
  overflow-y: scroll;
  height: 100%;
  .login-top {
    display: flex;
    justify-content: space-between;
    margin: 2.2rem auto 4rem;
    width: 90%;
    .login-text {
      font-size: 1.75rem;
      font-weight: bold;
      display: flex;
      text-align: left;
      flex-direction: column;
      .line {
        background: #222b45;
        border-radius: 2.5px;
        width: 3.1rem;
        height: 0.5rem;
        margin-top: 1.2rem;
      }
      span {
        font-family: PingFangSC-Medium;
        font-size: 2.8rem;
        color: #222b45;
        line-height: 4rem;
      }
    }
    .login-icon {
      width: 6.8rem;
      height: 6.8rem;
      background: url("../../assets/index/logo_img.png") center center no-repeat;
      background-color: #d6be93;
      // border: 0.875rem solid #8f9bb3;
      border-radius: 50%;
      opacity: 0.5;
      box-sizing: border-box;
    }
  }
}
.filedContainer {
  padding: 0 10%;
  height: 100%;
  background-color: white;
  // background-color: transparent;
}
.btSubmitStyle {
  width: 100%;
  border-radius: 5px;
  margin-top: 40px;
}

.checkboxStyle {
  bottom: 20px;
  /*padding-left: 25%;*/
  position: absolute;
  text-align: center;
  margin-top: 6rem;
  width: 100%;
  // background-color: transparent;

  /*flex 布局*/
  display: flex;
  /*实现垂直居中*/
  align-items: center;
  /*实现水平居中*/
  justify-content: center;
  text-align: justify;
  span {
    font-family: PingFangSC-Medium;
    font-size: 1.4rem;
    color: #d6be93;
    text-align: center;
    line-height: 1.4rem;
    text-decoration: underline;
  }
}
.has-get-code {
  opacity: 0.2;
  background: rgba(44, 44, 57, 0.2);
  border: 0 solid rgba(20, 20, 20, 0.4);
  border-radius: 4px;
  font-family: PingFangSC-Regular;
  font-size: 1.2rem;
  color: #141414;
  letter-spacing: 0;
  /*height: 2.1rem;*/
  /*line-height: 2.1rem;*/

  height: 3rem;
  line-height: 2.9rem;

  text-align: center;
  width: 7.2rem;
}
/deep/ .van-row {
  border-bottom: 1px solid #c2c2c2;
  width: 100%;
  overflow: hidden;
  height: 6.8rem;
  display: flex;
  align-items: flex-end;
  box-sizing: border-box;
  padding-bottom: 0.4rem;
}
/deep/ .icon-shouji1,
.icon-yanzhengma2,
.icon-mima {
  font-weight: 600;
  font-size: 2.2rem;
}
.go-back {
  display: inline-block;
  width: 100%;
  text-align: left;
  font-size: 2.4rem;
  margin: 2rem;
}
/deep/ .van-checkbox__label {
  font-size: 1.4rem;
}
</style>



// WEBPACK FOOTER //
// src/view/pages/register.vue